import { LightMode, Nightlight } from "@mui/icons-material";
import { IconButton, IconButtonProps, Slide, useColorScheme, useMediaQuery } from "@mui/material";

export default function ThemeSwitcher({ ...props }: IconButtonProps) {
  
  
  const {mode, setMode} = useColorScheme();
  const prefersDarkMode = useMediaQuery('(prefers-color-scheme: dark)');
  const changeMode = () => {
    if(mode == 'system') setMode(prefersDarkMode ? 'light' : 'dark');
    else setMode(mode == 'dark' ? 'light' : 'dark');
  }
  
  
  return (
    <IconButton
      {...props}
      onClick={changeMode}
      style={{ position: "relative", overflow: "hidden", width: 48, height: 48}}
    >
      <Slide direction="down" in={mode == "light" || (!prefersDarkMode && mode == "system")} mountOnEnter unmountOnExit>
        <Nightlight style={{ position: "absolute" }} />
      </Slide>
      <Slide
        direction="up"
        in={mode == "dark" || (prefersDarkMode && mode == "system")}
        mountOnEnter
        unmountOnExit
      >
        <LightMode style={{ position: "absolute" }} />
      </Slide>
    </IconButton>
  );
}
